module.exports = __webpack_public_path__ + "a699dbc010892ddacd075d6784ae6a80.svg";